import setAgentPreferences from 'actions/agent_preferences/set_agent_preferences';

export default class SetSidePanelWidth {
  constructor(context) {
    this.context = context;
  }

  // Called once when a resize drag ends (not on every mousemove), so this issues
  // one PUT per resize rather than one per frame.
  run({ width }) {
    if (!Number.isFinite(width) || width <= 0) {
      return;
    }

    const preferences = this.context.stores.agentPreferences.get();
    if (preferences.sidePanelWidth === width) {
      return;
    }
    preferences.setSidePanelWidth(width);

    this.context.analytics.track('Side Panel Resized', { sidePanelWidth: width });
    setAgentPreferences(this.context, preferences);
  }
}
